var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"annotation-audit-log-panel"},[(_vm.image)?_c('annotation-audit-log-list',{attrs:{"image":_vm.image.id,"index":_vm.index,"panel-layout":"","show-title":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }